import { render, staticRenderFns } from "./SousCible.vue?vue&type=template&id=141f5e70&"
import script from "./SousCible.vue?vue&type=script&lang=js&"
export * from "./SousCible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports